import { writable } from 'svelte/store'

export const previewLoading = writable(true)

export const konvaStageId = writable(null)

export const hidePreview = writable(false)
